import { useState, useCallback } from 'react';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import useHelpDeskFileUpload from '../../../hooks/useHelpDeskFileUpload';

export const INITIAL_VALUES = {
  employeeId: null,
  employeeName: '',
  branchId: null,
  categoryId: null,
  assignedAdminId: null,
  priority: null,
  shiftId: null,
  shiftDetails: null,
  title: '',
  description: '',
  attachments: []
};

const useCreateTicketForm = () => {
  const { accountId } = useAccount();
  const [currentPage, setCurrentPage] = useState(0);
  const [currentValues, setCurrentValues] = useState(INITIAL_VALUES);

  const handlePageChange = useCallback((page, values) => {
    if (values) {
      setCurrentValues((previous) => {
        // Exclude attachments — managed by useHelpDeskFileUpload, not RFF, so its [] would wipe uploads.
        const { attachments: _attachments, ...formValues } = values;
        return { ...previous, ...formValues };
      });
    }
    setCurrentPage(page);
  }, []);

  const updateValues = useCallback((patch) => setCurrentValues((previous) => ({ ...previous, ...patch })), []);

  const handleAttachmentUploaded = useCallback(
    (data) => setCurrentValues((previous) => ({ ...previous, attachments: [...(previous.attachments || []), data] })),
    []
  );
  const handleAttachmentRemoved = useCallback(
    (data) =>
      setCurrentValues((previous) => ({
        ...previous,
        attachments: (previous.attachments || []).filter((attachment) => attachment.fileId !== data.fileId)
      })),
    []
  );
  const fileUpload = useHelpDeskFileUpload({
    accountId,
    onUploaded: handleAttachmentUploaded,
    onRemoved: handleAttachmentRemoved
  });

  const resetAttachments = useCallback(() => {
    fileUpload.reset();
    setCurrentValues((previous) => ({ ...previous, attachments: [] }));
  }, [fileUpload]);

  return { currentPage, currentValues, updateValues, handlePageChange, fileUpload, resetAttachments };
};

export default useCreateTicketForm;
